import { render, staticRenderFns } from "./homePagePlacement.vue?vue&type=template&id=77245e85&scoped=true"
import script from "./homePagePlacement.vue?vue&type=script&lang=ts"
export * from "./homePagePlacement.vue?vue&type=script&lang=ts"
import style0 from "./homePagePlacement.vue?vue&type=style&index=0&id=77245e85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77245e85",
  null
  
)

export default component.exports